import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import './modal.style.css'
import IntlMessage from '../../helpers/intlMessage';

class ModalComponentAsync extends Component {
  constructor() {
    super()
    this.state = {
      modal: false
    };

    this.promiseInfo = {};
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    })
  }

  show = async () => {
    return new Promise((resolve, reject) => {
      this.promiseInfo = {
        resolve,
        reject
      };
      this.setState({
        modal: true
      });
    });
  };

  hide = () => {
    this.setState({
      modal: false
    });
  };

  render() {
    const { show } = this.state;
    const { resolve, reject } = this.promiseInfo;
    return (
      <div>
        <Modal
          size={this.props.size}
          isOpen={this.state.modal}
          style={this.props.style}

          visible={show}
          onCancel={() => {
            this.hide();
            reject();
          }}
        >
          <ModalHeader toggle={() => {
            this.hide()
            resolve()
          }}>
            {this.props.titulo}
          </ModalHeader>
          {this.props.noFooter ? (
            this.props.children
          ) : (
            <ModalBody>{this.props.children}</ModalBody>
          )}

          {!this.props.noFooter && (
            <ModalFooter>
              {typeof this.props.novo === 'function' ? (
                <Button
                  className='btn-novo'
                  color='primary'
                  onClick={this.novo.bind(this)}
                >
                  Novo
                </Button>
              ) : (
                undefined
              )}
              <Button
                className='modalComponente-fechar'
                color='secondary'
                onClick={() => {
                  this.hide()
                  resolve()
                }}
                tabIndex='-1'
              >
                <IntlMessage id = "dashboards.examDetail.close"/>
              </Button>
              {typeof this.props.confirma === 'function' ? (
                <Button
                  disabled={this.props.disabled}
                  color='primary'
                  onClick={this.confirma.bind(this)}
                >
                  Confirmar
                </Button>
              ) : (
                undefined
              )}
            </ModalFooter>
          )}
        </Modal>
      </div>
    )
  }

  cancela() {
    this.props.cancela()
    this.toggle()
  }

  confirma() {
    this.props.confirma()
    this.toggle()
  }

  novo() {
    this.props.novo()
    this.toggle()
  }

  getResolve() {
    const { resolve = () => { } } = this.promiseInfo || {};
    return (result) => {
      resolve(result);
      this.hide();
    };
  }

  getReject() {
    const { reject = () => { } } = this.promiseInfo || {};
    return (err) => {
      reject(err);
      this.hide();
    };
  }
}

ModalComponentAsync.propTypes = {
  titulo: PropTypes.string,
  texto: PropTypes.string,
  confirma: PropTypes.func,
  novo: PropTypes.func,
  visivel: PropTypes.bool,
  size: PropTypes.string
}

export default ModalComponentAsync




// WEBPACK FOOTER //
// ./src/componentes/modal/modal.async.js